import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { BaseStatusViewComponent } from '../base-status-view.component';
import { Kontrolltermin } from '../../../services/kontrolltermin.service';

@Component({
  selector: 'app-geloescht-view',
  templateUrl: './geloescht-view.component.html',
  styleUrls: ['./geloescht-view.component.scss']
})
export class GeloeschtViewComponent extends BaseStatusViewComponent implements OnInit {
  
  constructor(
    private router: Router,
    formBuilder: FormBuilder
  ) {
    super(formBuilder);
  }
  
  getStatusTitle(): string {
    return 'Gelöschter Kontrolltermin';
  }
  
  getAvailableActions(): string[] {
    return ['Wiederherstellen', 'Permanent löschen', 'Details anzeigen'];
  }
  
  getFormFields(): any[] {
    return [
      { field: 'deletion_reason', label: 'Löschgrund', type: 'textarea', readonly: true },
      { field: 'deleted_by', label: 'Gelöscht von', type: 'text', readonly: true },
      { field: 'deleted_at', label: 'Gelöscht am', type: 'datetime', readonly: true }
    ];
  }
  
  onSave(): void {
    this.logAction('Save');
    console.log('🗑️ GELÖSCHT: Save action triggered');
    // Restoration logic would go here
  }
  
  onCancel(): void {
    this.logAction('Cancel');
    console.log('🗑️ GELÖSCHT: Cancel action triggered');
    this.router.navigate(['/kontrolltermine']);
  }
  
  onStatusChange(newStatus: string): void {
    this.logAction(`Status change to ${newStatus}`);
    console.log('🗑️ GELÖSCHT: Status change to', newStatus);
    // Handle status change from geloescht
    this.emitStatusChange(newStatus);
  }
  
  // Geloescht-specific methods
  canRestore(): boolean {
    if (!this.kontrolltermin?.datum_durchfuerung) {
      return false;
    }
    const terminDate = new Date(this.kontrolltermin.datum_durchfuerung);
    const today = new Date();
    today.setHours(0, 0, 0, 0); // Reset time to start of day
    return terminDate >= today;
  }
  
  restoreKontrolltermin(): void {
    this.logAction('Restore');
    console.log('🗑️ GELÖSCHT: Restore action triggered');
    this.emitStatusChange('geplant'); // Restore to planned status
  }
}
